import { render, staticRenderFns } from "./ModalExchangeRateEdit.vue?vue&type=template&id=36ba0151&"
import script from "./ModalExchangeRateEdit.vue?vue&type=script&lang=js&"
export * from "./ModalExchangeRateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports